<template>
    <div class="row">
        <div class="col-xs-12 col-sm-8 offset-sm-2">            
            <div class="card">
                <div class="card-body text-center">                    
                    <h3 class="card-title" v-if="!error">
                        <span class="fa fa-spinner fa-spin text-success mr-1"></span>
                        Just a moment, getting ready...                
                    </h3>
                    
                    <div v-if="error">
                         <h3 class="card-title">
                            <span class="fa fa-exclamation-triangle text-warning mr-1"></span>
                            Sorry, we ran into an error
                        </h3>
                        <p style="font-size: 1.3em;">
                            But there's nothing to worry about. Please call our friendly team on 01904 468 881, who will be happy to help
                        </p>
                    </div>
                   
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'

    export default {
        props: {
            jobToken: String
        },
        data() {
            return {
                jobDetails: null,
                error: null
            }
        },
        async mounted() {
            try {
                let jobDetailsUrl = `/.netlify/functions/verify-job-info`
                let jobDetailsResult = await axios.post(jobDetailsUrl, {
                    job_token: this.jobToken
                })

                let checklistUrl = `/.netlify/functions/get-vendor-checklist-items`
                let checklistResult = await axios.get(checklistUrl)

                //this.jobDetails = jobDetailsResult.data
                this.$router.push({ 
                    name: 'vendor-checklist',
                    params: {
                        jobDetails: jobDetailsResult.data,
                        checklistTemplateProp: checklistResult.data
                    }
                })
            } catch (error) {
                this.error = error
                console.error(error.message)
            }
        }        
    }
</script>